import { setCustomerFeature } from "./featureRegistry";

/**
 * Customer-specific code gate. The only file in the codebase allowed to import
 * from src/features/pvl/. The condition uses import.meta.env.VITE_CUSTOMER,
 * which Vite replaces statically at build time, so non-PVL builds short-circuit
 * the dynamic import and Rollup drops the PVL chunk during tree-shaking.
 */
export const bootstrapCustomerFeatures = async (): Promise<void> => {
  if (import.meta.env.VITE_CUSTOMER === "pvl") {
    const mod = await import("./pvl");
    setCustomerFeature(mod.default);
  }
};
